var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"vue-codemirror"},[_c('label',[(_vm.label)?_c('span',[_vm._v(_vm._s(_vm.label))]):_vm._e(),_c('textarea',{ref:"textareaEditor",attrs:{"name":_vm.name,"placeholder":_vm.placeholder,"rows":"8","cols":"80"}})])])}
var staticRenderFns = []

export { render, staticRenderFns }